<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  props: {
    preset: Object
  },
  mixins: [messages, toasts],
  data() {
    return {
      item: null
    };
  },
  watch: {
    item: {
      deep: true,
      handler: "onUpdate"
    }
  },
  created() {
    if (this.preset) {
      this.update(this.preset);
    }
  },
  methods: {
    update(item) {
      this.item = item;
    },
    onUpdate() {
      this.$emit("update", this.item);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/ModelForm.vue